import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageCountriesAwards,
  DeleteCountriesAwards,
  EditCountriesAwards,
  GetCountriesAwards,
} from "./actions";
import GuardedModal from "src/pages/catalogue/GuardedModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  confirmDelete,
  deleteTitle,
  pickRows,
  useLocalSearch,
} from "src/pages/catalogue/helpers";
import { useLocation, useParams } from "react-router";
import Trail, { countryTrail } from "src/components/shared/Trail";
import { useCountry } from "src/pages/catalogue/context";

const CountriesAwards = () => {
  const { id } = useParams();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  const Schema = Yup.object().shape({
    title: Yup.string().trim().required("Enter the award's name."),
    vote: Yup.string().trim().required("Enter the vote or rating shown with the award."),
    image: Yup.string().trim().required("Choose an image to upload."),
  });
  const location = useLocation();
  // Names come from the API when the screen is opened from a link.
  const dataCountry = useCountry(id, location.state);
  const finder = useLocalSearch(data, ["title", "vote"]);

  const askDelete = (rows) =>
    confirmDelete(Commonalert, {
      title: deleteTitle("award", rows, (row) => row.title),
      message: `It disappears from ${
        dataCountry?.name ? `the ${dataCountry.name}` : "the country"
      } page on the website. You can restore it from the Activity log.`,
      onConfirm: () =>
        dispatch(
          DeleteCountriesAwards({
            callback: () => GetData({ tableName: null, type: null }),
            id: rows.map((row) => row.id),
          })
        ),
    });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetCountriesAwards({
        country_id: id,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
          } else {
            setData([]);
          }
          setLoadingData(false);
        },
      })
    );
    if (array.length == 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
        {
          failed: "title",
          type: inputType.text,
          title: "Title",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "vote",
          type: inputType.text,
          title: "Vote",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "image",
          type: inputType.image,
          title: "Award image (JPG, PNG, WEBP or GIF)",
          placeholder: "",
          fullwidth: true,
          fileTypes: ["JPG", "PNG", "JPEG", "WEBP", "GIF"],
          multiple: false,
          label: "Drop an image here, or click to choose one",
          fileOrFiles: "File", //Array or File or null
        },
      ]);
    }
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "title" },
    { type: columntype.image, name: "image" },
    { type: columntype.text, name: "vote" },
    { type: columntype.date, name: "created_date" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
      withSort: true,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      withSort: false,
    },
    {
      id: "vote",
      numeric: false,
      disablePadding: false,
      label: "Vote",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "created_date",
      numeric: false,
      disablePadding: false,
      label: "Created date",
      withSort: true,
    },
    (dataPrivileges["4"]?.access_edit == 1 ||
      dataPrivileges["4"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["4"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
      },
    },
    dataPrivileges["4"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) askDelete([row]);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditCountriesAwards({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: (res) => {
          // Only flip the switch when the server took the change.
          if (res) updateDataLocal({ id: row.id, failedName, newData });
          else setloadingEditdatatype("");
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <Trail items={countryTrail(dataCountry, "Awards", id)} />
      <DynamicTable
        // Names the row for screen readers ("Checks expiry: Passport First Page").
        getRowLabel={(row) => row.title || `#${row.id}`}
        subtitle="Awards and rankings shown on the country page of the website."
        nameTable={dataCountry?.name ? `Awards · ${dataCountry.name}` : "Awards"}
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(ListIds) => askDelete(pickRows(data, ListIds))}
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        emptyTitle={finder.emptyTitle("No awards yet")}
        emptyHint={finder.emptyHint(
          "Awards and rankings the destination has won, shown on its page of the website."
        )}
        handleSearch={finder.onSearch}
        items={finder.filtered} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={finder.query} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["4"]?.access_write == 1 ? true : false}
        withDeleteItem={dataPrivileges["4"]?.access_delete == 1 ? true : false}
        withEditItem={dataPrivileges["4"]?.access_edit == 1 ? true : false}
        withPagination={false}
        withSearch={true}
        canBack
      />
      {showModal ? (
        <GuardedModal
          discardTitle={editMode ? "Discard your changes to this award?" : "Discard this award?"}
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={editMode ? "Edit award" : "Add an award"}
          editMode={editMode}
          description="Shown on the country's page of the website."
          buttonTitle={editMode ? "Save changes" : "Add award"}
          onSubmit={(valuess) => {
            dispatch(
              ManageCountriesAwards({
                country_id: id,
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default CountriesAwards;
